mutation ActivityDelete($input: ActivityDeleteInput!) {
    activityDelete(input: $input) {
        activity {
            id
        }
    }
}
